// extracted by mini-css-extract-plugin
var _1 = "BoardAddPopup_checkboxWrapper__dCAFR";
var _2 = "BoardAddPopup_checkboxesWrapper__uBDKv";
var _3 = "BoardAddPopup_dropdownMenu__G23A0";
var _4 = "BoardAddPopup_field__3HdyA";
var _5 = "BoardAddPopup_importButton__sR+QI";
var _6 = "BoardAddPopup_submitButton__W9HlF";
var _7 = "BoardAddPopup_text__yLcqk";
export { _1 as "checkboxWrapper", _2 as "checkboxesWrapper", _3 as "dropdownMenu", _4 as "field", _5 as "importButton", _6 as "submitButton", _7 as "text" }
